import { Checkbox } from 'antd';
import { HTMLAttributes } from 'react';
import { OutsourcingBenefits } from '../../enums';
import { snakeCaseToWord } from '../../utils/strings';
import { BenefitsContainer } from './styles/outsourcing-benefits';
import { useTheme } from 'styled-components';

export const OutsourcingBenefitsSelector: React.FC<
	HTMLAttributes<HTMLDivElement> & { onBenefitsChange: (benefits) => void }
> = ({ onBenefitsChange }) => {
	const theme = useTheme();

	return (
		<div className="w-100">
			<h4>Outsourcing Benefits</h4>
			<p className="text-muted">You can choose to add any of these benefits to your employees</p>
			<BenefitsContainer onChange={onBenefitsChange}>
				{Object.keys(OutsourcingBenefits).map(benefit => (
					<Checkbox key={benefit} value={benefit} className="me-2 me-md-5">
						{snakeCaseToWord(benefit)}
					</Checkbox>
				))}
			</BenefitsContainer>
			<p style={{ color: theme.TA_GREEN }}>Prices start at $150 / month</p>
		</div>
	);
};
